export default __webpack_public_path__ + "static/media/games3.eaad9317.png";